
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import dateFormat from 'vux/src/tools/date/format.js'


export default {
name:'ProductMgr',
components: {
Flexbox,
FlexboxItem,
Tabbar,
TabbarItem,
Panel,
XHeader,
Rater,
XButton,
dateFormat
},
mounted(){
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
this.currentUser=this.GLOBAL.currentUser;
console.log(this.currentUser);
if(this.currentUser.ExpireDate==null){
this.currentUser.ExpireDateZH = '0000年00月00日';
}
else{
this.currentUser.ExpireDateZH = dateFormat(new Date(this.currentUser.ExpireDate), 'YYYY年MM月DD日');
}
if(this.currentUser.CardNo==null||this.currentUser.CardNo==''){
this.currentUser.CardNo='0000 0000 0000';
}
if(this.currentUser.Status==-1){
this.currentUser.Level='待激活账号';
}
else if(this.currentUser.Status==3){
this.currentUser.Level='待审核账号';
}
else if(this.currentUser.Status==0){
this.currentUser.Level='审核不通过账号';
}
else if(this.currentUser.Status==1||this.currentUser.Status==2){
if(this.currentUser.BType==0){
this.currentUser.Level='试用会员';
}
else if(this.currentUser.BType==1){
this.currentUser.Level='黄金会员';
}
}
},
methods: {
onImgError (item, $event) {
console.log(item, $event)
},
ActiveMember(){
console.log('ActiveMember');
this.$router.push({ path: '/BusinessDetail?tag=A' });
},
RenewMember(){

}
},
data () {
return {
dataRange:5,
currentUser:{}
}
}
}



// WEBPACK FOOTER //
// ./src/components/BusinessModules/MemberMgr.vue